module.exports = __webpack_public_path__ + "static/media/hot-safari.e8e0970f.gif";